<template>
  <v-app>
    <v-app-bar
      v-if='!homePage'
      flat
      app
      clipped-left
      color='#fff'
    >
      <ambiaheader />
    </v-app-bar>

    <sidebar
      v-if='!homePage'
      product360
    />

    <v-content v-scroll='scroll' touchless>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import Sidebar from '@/layout/sidebar'
import Ambiaheader from '@/layout/header'
import throttle from 'lodash/throttle'

import htmlHelper from '@/helpers/html'
export default {
  components: {
    Ambiaheader,
    Sidebar,
  },
  data: () => ({
    scroll: null,
  }),
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    },
    homePage() {
      if (this.$route.path == '/login' || this.$route.path == '/signup' || this.$route.path == '/mylists' ) {
        return true
      } else {
        return false
      }
    },
  },
  created () {
    // The parameter "500" is used on throttle to prevent multiple API calls when
    // scrolling. This number was enough to fix the issue.
    this.scroll = throttle(this.emitScroll, 500)
  },
  methods: {
    emitScroll(){
      if (htmlHelper.isAtTheBottomOfThePage())
        this.$bus.$emit('handle-infinite-scroll')
    }
  }
}
</script>
